enum ETerms {
  getTerms = 'terms/get',
}

export default ETerms;
